export default __webpack_public_path__ + "static/media/build-quality.a93e1afc.webp";